import React from 'react';
import YoutubePlayButton from '../Button/YoutubePlayButton';
import YoutubeBrandingText from '../Typography/YoutubeBrandingText';

function YoutubeOverlayPlay() {
  return (
    <>
      {/* Play button overlay */}
      <YoutubePlayButton />

      {/* YouTube branding (optional) */}
      <YoutubeBrandingText />
    </>
  );
}

export default YoutubeOverlayPlay;
